// extracted by mini-css-extract-plugin
export default {"warning":"style_warning__K6hWF","heading":"style_heading__W1RHr"};